import { defineComponent as _defineComponent } from 'vue'
import { JointOption } from '@/modules/ConfiguratorJoints/composables/useOptions';
import { JointsParameterRow } from '@/modules/ConfiguratorJoints/helpers/JointsConfiguration';

interface Props {
    parameterRows: JointsParameterRow[];
    options: JointOption[];
    showAdditionalOptions: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JointsParameterList',
  props: {
    parameterRows: null,
    options: null,
    showAdditionalOptions: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})